<template>
  <section class="co-bg-striped">
    <div class="co-container-lg flex flex-col items-center justify-center gap-4 py-8 md:flex-row md:gap-4 md:px-4 lg:py-0 xl:px-0">
      <div>
        <img
          src="~/assets/images/Te/TeTop/BizBanner/banner-photo.webp"
          width="618"
          height="282"
          loading="lazy"
          class="mx-auto md:w-[32.5rem] lg:w-[38.625rem]"
          alt="プログラミング・生成AI・新人研修"
        >
      </div>
      <div class="px-4 text-center md:px-0">
        <h2 class="mb-2 text-center">
          <img
            src="~/assets/images/Te/TeTop/BizBanner/biz-banner-title.svg"
            alt="エンジニア研修 生成AI研修"
            width="499"
            height="66"
            loading="lazy"
            class="mx-auto md:w-[23.125rem] xl:w-auto"
          >
        </h2>
        <div class="co-display-6 mb-5 font-bold leading-normal md:mb-3">
          お探しの企業様へ
        </div>
        <div class="co-display-11 mb-2 flex justify-center gap-2">
          <img
            src="~/assets/images/Te/TeTop/BizBanner/biz-banner-diagonal-line.svg"
            alt="斜線"
            width="13"
            height="24"
            loading="lazy"
          >
          成果が見える  即戦力が育つ
          <img
            src="~/assets/images/Te/TeTop/BizBanner/biz-banner-diagonal-line.svg"
            alt="斜線"
            width="13"
            height="24"
            loading="lazy"
            class="-scale-x-100"
          >
        </div>
        <a
          class="co-btn-primary"
          href="https://tokyoitschool.jp/service/techacademy/"
          target="_blank"
        >
          テックアカデミーIT研修
          <FontAwesomeIcon
            :icon="faAngleRight"
            class="fa-fw inline h-3 w-2"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faAngleRight,
    }
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
